// Celebrity data service for API calls
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8747';
console.log('API_BASE_URL:', API_BASE_URL);

class CelebrityService {
  async getAllCelebrities(tier = null) {
    try {
      const url = tier 
        ? `${API_BASE_URL}/celebrities?tier=${encodeURIComponent(tier)}`
        : `${API_BASE_URL}/celebrities`;
      
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch celebrities');
      return await response.json();
    } catch (error) {
      console.error('Error fetching celebrities:', error);
      throw error;
    }
  }

  async getCelebrityTiers() {
    try {
      const response = await fetch(`${API_BASE_URL}/celebrities/tiers`);
      if (!response.ok) throw new Error('Failed to fetch celebrity tiers');
      return await response.json();
    } catch (error) {
      console.error('Error fetching celebrity tiers:', error);
      throw error;
    }
  }

  async getCelebrityById(pbId) {
    try {
      const response = await fetch(`${API_BASE_URL}/celebrity/${pbId}`);
      if (!response.ok) throw new Error('Celebrity not found');
      return await response.json();
    } catch (error) {
      console.error('Error fetching celebrity:', error);
      throw error;
    }
  }

  async getCelebrityInvestments(pbId, params = {}) {
    try {
      const queryParams = new URLSearchParams(params);
      const response = await fetch(
        `${API_BASE_URL}/celebrity/${pbId}/investments?${queryParams}`
      );
      if (!response.ok) throw new Error('Failed to fetch investments');
      return await response.json();
    } catch (error) {
      console.error('Error fetching investments:', error);
      throw error;
    }
  }

  async compareCelebrities(celebrityIds) {
    try {
      const response = await fetch(`${API_BASE_URL}/compare`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ celebrity_ids: celebrityIds }),
      });
      if (!response.ok) throw new Error('Failed to compare celebrities');
      return await response.json();
    } catch (error) {
      console.error('Error comparing celebrities:', error);
      throw error;
    }
  }

  async searchCelebrities(query) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/search?q=${encodeURIComponent(query)}`
      );
      if (!response.ok) throw new Error('Search failed');
      return await response.json();
    } catch (error) {
      console.error('Error searching celebrities:', error);
      throw error;
    }
  }

  async getIndustryAnalytics(industry = null) {
    try {
      const url = industry
        ? `${API_BASE_URL}/industries?industry=${encodeURIComponent(industry)}`
        : `${API_BASE_URL}/industries`;
      
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch industry analytics');
      return await response.json();
    } catch (error) {
      console.error('Error fetching industry analytics:', error);
      throw error;
    }
  }

  async getPlatformStats() {
    try {
      const response = await fetch(`${API_BASE_URL}/stats`);
      if (!response.ok) throw new Error('Failed to fetch platform stats');
      return await response.json();
    } catch (error) {
      console.error('Error fetching platform stats:', error);
      throw error;
    }
  }
}

export default new CelebrityService();